import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { Router } from '@angular/router';

const AUTH_TOKEN_API_URL            = `${environment.api.baseUrl ?? ""}${environment.api.services.authenticationToken}`;
const AUTH_REFRESH_TOKEN_API_URL    = `${environment.api.baseUrl ?? ""}${environment.api.services.authenticationRefreshToken.url}`;
const BI_SESSION_API_URL            = `${environment.api.baseUrl ?? ""}${environment.api.services.biSession.url}`;
const BI_SAMPLE_SESSION_API_URL     = `${environment.api.baseUrl ?? ""}${environment.api.services.sampleBiSession.url}`;
const SURVEY_REPORT_API_URL         = `${environment.api.baseUrl ?? ""}${environment.api.services.surveyReport.url}`;
const IMPORT_API_URL                = `${environment.api.baseUrl ?? ""}${environment.api.services.importLaunch.url}`;
const LAUNCH_ORCHESTRATOR_API_URL   = `${environment.api.baseUrl ?? ""}${environment.api.services.launchOrchestrator.url}`;
const LAUNCH_API_URL                = `${environment.api.baseUrl ?? ""}${environment.api.services.launch.url}`;
const ORGANIZATION_API_URL          = `${environment.api.baseUrl ?? ""}${environment.api.services.organization.url}`;
const ORGANIZATION_API_URL_2        = `${environment.api.baseUrl ?? ""}${environment.api.services.organizationV2.url}`;
const QUESTION_API_URL              = `${environment.api.baseUrl ?? ""}${environment.api.services.question.url}`;
const QUESTION_API_URL_2            = `${environment.api.baseUrl ?? ""}${environment.api.services.questionV2.url}`;
const RESPONSE_API_URL              = `${environment.api.baseUrl ?? ""}${environment.api.services.response.url}`;

/**
 * This interceptor just throws you to error page whenever the authentication faces and error and also for refresh.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiInterceptor implements HttpInterceptor {

  constructor(
    private _router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError( (httpErrorResponse: HttpErrorResponse) => {
        this._handleAPIError(request, httpErrorResponse);
        throw httpErrorResponse;
      })
    ) as Observable<HttpEvent<any>>;
  }

  /**
   * 
   * @param request 
   * @param httpErrorResponse 
   */
  private _handleAPIError(request: HttpRequest<any>, httpErrorResponse: HttpErrorResponse) {
    // authentication api
    if(request.url.includes(AUTH_TOKEN_API_URL) || request.url.includes(AUTH_REFRESH_TOKEN_API_URL)) {
      this._handleAuthenticationApi(httpErrorResponse)
    } // add more api urls
  }

  /**
   * 
   * @param httpErrorResponse 
   */
  private _handleAuthenticationApi(httpErrorResponse: HttpErrorResponse) {
    switch(httpErrorResponse.status) {
      case 0: // TODO - 0 represents INTERNAL_SERVER_ERROR CORS
        this._router.navigate(['error'], { 
          state: { errorCode: 500 } 
        })
        break;
      default:
        break;
    }
  }

}